import { createSlice } from "@reduxjs/toolkit";
  import { loginUser, logoutUser, checkSession } from "../thunks/authThunks";

interface User {
  id: number;
  username: string;
  role: "admin" | "user";
}

const initialState = {
  user: null as User | null,
  isAuthenticated: false,
  error: null as string | null,
  loading: false,
};


const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
      // Sets the logged-in user and marks as authenticated
      setUser: (state, action) => {
        state.user = action.payload.user;
        state.isAuthenticated = true;
        state.error = null;
      },
  
      // Clears the user and resets authentication
      logout: (state) => {
        state.user = null;
        state.isAuthenticated = false;
        state.error = null;
      },
  
      // Sets an error message (e.g. failed login)
      setError: (state, action) => {
        state.error = action.payload.message;
      },
  
      // Optional: clear the error
      clearError: (state) => {
        state.error = null;
      },
    },
    extraReducers: (builder) => {
        builder
          .addCase(loginUser.pending, (state) => {
            state.error = null;
            state.loading = true;
          })
          .addCase(loginUser.fulfilled, (state, action) => {
            state.user = action.payload.user;
            state.isAuthenticated = true;
            state.error = null;
            state.loading = false;
          })
          .addCase(loginUser.rejected, (state, action) => {
            state.error = action.payload || 'Login failed';
            state.loading = false;
          })
          .addCase(logoutUser.fulfilled, (state, action) => {
            state.user = null;
            state.isAuthenticated = false;
            state.error = null;
            state.loading = false;
          })
          .addCase(logoutUser.rejected, (state, action) => {
            state.error = action.payload || 'Logout failed';
            state.loading = false;
          })
          .addCase(logoutUser.pending, (state) => {
            state.error = null;
            state.loading = true;
          })
          // Add checkSession cases
          .addCase(checkSession.pending, (state) => {
            state.loading = true;
          })
          .addCase(checkSession.fulfilled, (state, action) => {
            state.user = action.payload.user;
            state.isAuthenticated = action.payload.isAuthenticated;
            state.error = null;
            state.loading = false;
          })
          .addCase(checkSession.rejected, (state, action) => {
            state.user = null;
            state.isAuthenticated = false;
            state.error = action.payload || 'Session check failed';
            state.loading = false;
          })
      },
  });
  
  export const { setUser, logout, setError, clearError } = authSlice.actions;
  export default authSlice.reducer;